import { Injectable } from "@angular/core";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

@Injectable({
    providedIn: 'root'
  })
  export class DownloadFileService {
      
    openPDF(data, reportname, Head, orientation): void {
        var doc = new jsPDF({ orientation: orientation });
        doc.setFontSize(18);
        doc.text(reportname, 11, 8);
        doc.setFontSize(11);
        doc.setTextColor(100);
        (doc as any).autoTable({
          head: Head,
          body: data,
          columnWidth: '50%',
          theme: 'plain',
          styles: { cellWidth: 'auto', minCellWidth: 21 },
          didDrawCell: (data) => { },
        });
        // Open PDF in new tab via safe blob URL (avoids jsPDF dataurlnewwindow HTML injection)
        const pdfBlob = doc.output('blob');
        const blobUrl = URL.createObjectURL(pdfBlob);
        window.open(blobUrl, '_blank');
        // below line for Download PDF document
        doc.save(reportname + new Date().getTime());
      }

      exportExcel(workbook, data, ReportName) {
        workbook.xlsx.writeBuffer().then((data) => {
          let blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = ReportName;
          a.click();
          URL.revokeObjectURL(url);
        });
      }

  }